export const dateFormatter = (date, length = "long") => {
  if (!date) return null;

  const dateObject = new Date(date);

  if (isValidDate(dateObject)) {
    switch (length) {
      case "short":
        return dateObject.toLocaleDateString("nl-BE", {
          weekday: "long",
          day: "numeric",
          month: "long"
        });

      default:
        return dateObject.toLocaleDateString("nl-BE", {
          weekday: "long",
          day: "numeric",
          month: "long",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        });
    }
  }

  return null;
};

export function cityToBounds(city) {
  return null;
}

export function markerToBounds(marker) {
  return null;
}

export function belgiumBounds() {
  return {
    viewport_ne_lng: 2.51357303225,
    viewport_ne_lat: 50.5294835476,
    viewport_sw_lng: 6.15665815596,
    viewport_sw_lat: 51.4750237087
  };
}

export function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export const randomID = (length = 8) => {
  const ALPHABET =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let rtn = "";
  for (let i = 0; i < length; i += 1) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
  }
  return rtn;
};

export const em = (size, base = 16) => `${size / base}em`;

export const urlStringFormatter = string => {
  return string
    .replace(/[^\w]/g, " ")
    .replace(/\d/g, " ")
    .trim()
    .replace(/\s/g, "-")
    .replace(/-+/g, "-")
    .toLowerCase();
};



// WEBPACK FOOTER //
// ./src/utils.js